import getIsPortrait from "selectors/breakpoint/getIsPortrait";
import { createSelector } from "reselect";

import { BreakpointDefinition } from "utils/Breakpoint";

import getBreakpoint from "./getBreakpoint";

const getUseSwipeableInterview = createSelector(
  [getBreakpoint, getIsPortrait],
  (breakpoint, isPortrait) => {
    if (isPortrait) {
      return true;
    }
    return breakpoint.isLessThanOrEquals(BreakpointDefinition.XS);
  },
);

export default getUseSwipeableInterview;
